import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const countryAPI = {
    getAll: async () => {
        try {
            const { data } = await api.get('/api/countries');
            return data;
        } catch (error) {
            handleApiError(error, 'Get all countries error:');
        }
    }
}